import { render } from "./TarteAuCitron.vue?vue&type=template&id=174a4e96&ts=true"
import script from "./TarteAuCitron.vue?vue&type=script&lang=ts"
export * from "./TarteAuCitron.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__